// e-Fatura Kayıtlı Kullanıcı (mükellef) Sorgulama penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.einvoiceUserQuery';

export const einvoiceUserQueryGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'e-Fatura mükellefi nasıl sorgulanır?'),
  intro: t(`${G}.intro`, 'Fatura alıcısının e-Fatura mükellefi olup olmadığını sorgularsınız. Mükellefse e-Fatura, değilse e-Arşiv Fatura düzenlemeniz gerekir. Sorgu yalnız bilgi verir; hiçbir kayıt oluşturmaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'E-Fatura Kayıtlı Kullanıcı Sorgulama'),
    body: t(`${G}.regions.body`, 'Entegrasyon, VKN/TCKN, sonuç'),
    footer: t(`${G}.regions.footer`, 'Kapat / Yeni Sorgulama'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Aktif entegrasyonu kontrol edin'),
      text: t(`${G}.s1.text`, 'Sorgu, şirketinizin aktif e-Fatura entegrasyonu üzerinden yapılır. Pencerenin üstünde yeşil kutuda "Aktif Entegrasyon" ve kullanıcı adı yazar.'),
      tips: [
        t(`${G}.s1.tip1`, '"Aktif bir e-Fatura entegrasyonu bulunamadı" yazıyorsa önce e-Fatura entegrasyon ayarlarını yapın; entegrasyon yokken sorgu alanı görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. VKN veya TCKN girip sorgulayın'),
      text: t(`${G}.s2.text`, 'Alıcının 10 haneli vergi numarasını (VKN) ya da 11 haneli T.C. kimlik numarasını (TCKN) yazın; alana yalnız rakam girilebilir. "Sorgula"ya ya da Enter tuşuna basın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sonucu okuyun'),
      text: t(`${G}.s3.text`, '"Kullanıcı Bulundu" çıkarsa alıcı e-Fatura mükellefidir: Ünvan, VKN/TCKN, Etiket Adresi, E-Fatura Kayıt Zamanı ve Kuruluş Tipi (Kamu Kuruluşu / Özel Sektör) görünür. "Bu VKN/TCKN e-Fatura mükellefi değil" yazarsa bu alıcıya e-Arşiv Fatura düzenlemelisiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kayıt zamanından önceki bir tarihe e-Fatura düzenlenemez; bu durumda da e-Arşiv Fatura düzenlemeniz gerekir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Yeni sorgu veya kapat'),
      text: t(`${G}.s4.text`, '"Yeni Sorgulama" alanı temizleyip başka bir numara sorgulamanızı sağlar. "Kapat" pencereyi kapatır; girdiğiniz numara ve sonuç silinir.'),
    },
  ],
});
